import { useAuthContext } from "../Modules/Auth/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../Environment/firebase";
import mnist from "../Images/MNiST.png";
import msta from "../Images/logo192.png";
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { lightBlue } from "@mui/material/colors";
import { MstaFontFamily } from "../Functions/Style/MstaFont";
import { Divider } from "@mui/material";

const pages = ["ホーム", "正常画像", "症例検索", "疾患一覧", "問題演習", "CT・MRI入門"];
//Diseaseを消す
const settings = ["マイページ", "ログアウト"];
const anonymous = ["ログイン"];

export const Header = (): JSX.Element => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const { user, agree } = useAuthContext();
  const navigate = useNavigate();
  const [hoveredPage, setHoveredPage] = React.useState("");

  const location = useLocation();
  const locationPath = location.pathname === '/' ? 'ホーム' : location.pathname.split("/")[1];

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logout = () => {
    auth.signOut();
    window.location.href = "/";
  };

  const handleOpenLink = (element: string) => {
    let position = 0;
    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
    if (element === "ホーム") {
      navigate("/");
    } else if (element === "正常画像") {
      navigate("/basic");
    } else if (element === "症例検索") {
      navigate("/catalogue/search");
    } else if (element === "疾患一覧") {
      navigate("/catalogue/disease");
    } else if (element === "CT・MRI入門") {
      window.open("https://sites.google.com/mnes.org/msta-tutorial/%E3%83%9B%E3%83%BC%E3%83%A0", "_blank");
    } else if (element === "問題演習") {
      navigate("/mstudy");
    } else if (element === "マイページ") {
      navigate("/mypage/account");
    } else if (element === "ログアウト") {
      logout();
    } else if (element === "ログイン") {
      navigate("/login");
    }
  };

  return (
    <AppBar
      position="sticky"
      sx={{ background: lightBlue[400], fontFamily: MstaFontFamily }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <Avatar alt="Remy Sharp" sx={{ width: 50, height: 50, bgcolor: 'white', display: { xs: 'none', md: 'flex' } }}>
            <img src={msta}
              alt='Msta Logo'
              width="42"
              height="42" />
          </Avatar> */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "space-between",
            }}
          >
            <Box
              alignItems="center"
              sx={{
                display: { xs: "none", md: "flex" },
                ":hover": {
                  cursor: "pointer",
                },
              }}
              onClick={() => {
                handleCloseNavMenu();
                handleOpenLink("ホーム");
              }}
            >
              <Avatar
                alt="Remy Sharp"
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "white",
                  display: { xs: "none", md: "flex" },
                  alignItems: "center",
                }}
              >
                <img src={msta} alt="Msta Logo" width="32" height="32" />
              </Avatar>
              <Typography ml={1} fontSize={28} fontWeight="bold">
                Msta
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {pages.map((page, index) => (
                <Button
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu();
                    handleOpenLink(page);
                  }}
                  onMouseEnter={() => setHoveredPage(page)}
                  onMouseLeave={() => setHoveredPage("")}
                  sx={{
                    my: 1,
                    color: lightBlue[900],
                    display: "block",
                    mr: 3,
                    textTransform: "none",
                    position: "relative",
                  }}
                >
                  <Typography
                    fontSize={20}
                    fontWeight="bold"
                    sx={{
                      // textShadow: "1px 1px 1px rgba(0,0,0,0.1)",
                      position: "relative",
                      "&::after": {
                        content: "''",
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "2px",
                        backgroundColor: lightBlue[900],
                        // backgroundColor: "white",
                        transform: `scaleX(${
                          hoveredPage === page ||
                          (location.pathname === '/' && page === 'ホーム') ||
                          (location.pathname === '/basic' && page === '正常画像') ||
                          (location.pathname.startsWith('/catalogue/search') && page === '症例検索') ||
                          (location.pathname.startsWith('/catalogue/disease') && page === '疾患一覧') ||
                          (location.pathname.startsWith('/mstudy') && page === '問題演習')
                            ? 1
                            : 0
                        })`,
                        transformOrigin: "left",
                        transition: "transform 0.5s ease",
                      },
                    }}
                  >
                    {page}
                  </Typography>
                </Button>
              ))}
            </Box>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <DragHandleIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu();
                    handleOpenLink(page);
                  }}
                >
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Avatar
            alt="Remy Sharp"
            sx={{
              width: 40,
              height: 40,
              bgcolor: "white",
              display: { xs: "flex", md: "none" },
            }}
          >
            <img src={msta} alt="Msta Logo" width="32" height="32" />
          </Avatar>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, ml: 0.5 }}
          >
            Msta
          </Typography>
          {agree ? (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title={user?.displayName}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src={user?.photoURL || ""} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => {
                      handleCloseNavMenu();
                      handleOpenLink(setting);
                    }}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ) : (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="ゲスト">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon sx={{ fontSize: 60 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {anonymous.map((anno) => (
                  <MenuItem
                    key={anno}
                    onClick={() => {
                      handleCloseNavMenu();
                      handleOpenLink(anno);
                    }}
                  >
                    <Typography textAlign="center">{anno}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
